<template>
  <div class="setting-1">
    <!--    按钮× 所在行-->
    <div class="close-box">
      <i
        data-io-click="tracker"  @click.stop="closeSetDialog"
        class="el-dialog__close el-icon el-icon-close setting-open-method-icon"
      ></i>
    </div>
    <!--    文字所在行-->
    <div>
      <div class="font1">设置</div>
      <div class="font2">切换你喜欢的[详情页]打开方式</div>
    </div>
    <!--    设置展示图片及按钮 所在行-->
    <div style="margin-top: 36px">
      <div data-io-click="tracker"  @click="setDocDetailOpenMethod('1')" class="tanchuang-fangshi">
        <div
          class="preview-set-dialog-div"
          @mouseover="playVideo(1)"
          @mouseout="pauseVideo(1)"
        >
          <video
            ref="myVideo1"
            loop
            class="icon preview-set-dialog"
            :class="{ 'icon preview-set-dialog-on': openMethod === '1' }"
          >
            <source src="../../../assets/video/quanping.mp4" type="video/mp4" />
          </video>
        </div>
        <div style="text-align: center; margin-top: 5px">
          <i
            class="icon radio"
            :class="{ 'icon radio-on': openMethod === '1' }"
          ></i>
          <span class="font3">全屏</span>
        </div>
      </div>
      <div data-io-click="tracker"  @click="setDocDetailOpenMethod('2')" class="tanchuang-fangshi">
        <div
          class="preview-set-dialog-div"
          @mouseover="playVideo(2)"
          @mouseout="pauseVideo(2)"
        >
          <video
            ref="myVideo2"
            class="icon preview-set-dialog"
            :class="{ 'icon preview-set-dialog-on': openMethod === '2' }"
          >
            <source src="../../../assets/video/cehua.mp4" type="video/mp4" />
          </video>
        </div>
        <div style="text-align: center; margin-top: 5px">
          <i
            class="icon radio"
            :class="{ 'icon radio-on': openMethod === '2' }"
          ></i>
          <span class="font3">侧边滑出</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import api from "@/assets/js/service/api";

export default {
  data() {
    return {
      //详情页打开方式
      openMethod: null,
    };
  },
  mounted() {
    this.getDocDetailOpenMethod();
  },
  methods: {
    //打开详情页展示的设置页面
    closeSetDialog(event) {
      // event.stopPropagation();
      this.$emit("closeSetDialog", null);
    },
    async setDocDetailOpenMethod(openMethod) {
      const data = await request.post(api.document.setDocDetailOpenMethod, {
        openMethod,
      });
      if (data.result) {
        this.getDocDetailOpenMethod();
        this.closeSetDialog();
        this.$message.success("切换成功!");
      }
    },
    //获取用户的详情页打开方式
    async getDocDetailOpenMethod() {
      const data = await request.get(api.document.getDocDetailOpenMethod, {
        isFromXkw: false,
      });
      this.openMethod = data.result;
    },
    playVideo(num) {
      if (num == 1) {
        this.$refs.myVideo1.loop = true;
        this.$refs.myVideo1.play();
      } else {
        this.$refs.myVideo2.loop = true;
        this.$refs.myVideo2.play();
      }
    },
    pauseVideo(num) {
      if (num == 1) {
        this.$refs.myVideo1.pause();
      } else {
        this.$refs.myVideo2.pause();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.preview-set-dialog {
  width: 415px;
  height: 252px;
  box-shadow: 0px 3.12px 6.24px 0px rgba(0, 40, 120, 0.02),
    0px 6.24px 14.04px 0px rgba(0, 40, 120, 0.03),
    0px 9.36px 31.2px 0px rgba(0, 40, 120, 0.05);
  border-radius: 11px;
}
.preview-set-dialog-on {
  border: 2px solid #0057ff;
}
.preview-set-dialog-div:hover {
  transform: scale(0.99);
}
.radio {
  width: 16px;
  height: 16px;
  content: url("~@/assets/images/radio.png");
  margin-right: 8px;
}
.radio-on {
  content: url("~@/assets/images/radio-on.png");
}
.font1 {
  color: var(-----xkw-font-primary-color, #1a1a1a);
  text-align: center;
  /* Medium/--xkw-prtitle-medium */
  font-family: "PingFang SC";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px; /* 136.364% */
}
.font2 {
  color: var(-----xkw-font-sectitle-color, #7e7e7e);
  text-align: center;
  /* regular/--xkw-body-regular */
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
}
.font3 {
  color: var(-----xkw-font-primary-color, #1a1a1a);
  /* regular/--xkw-body-regular */
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
}
.tanchuang-fangshi {
  margin-left: 28px;
  display: inline-block;
}

.setting-1 {
  height: 438px;
  width: 912px;
  z-index: 3001;
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: rgb(255, 255, 255);
  border-radius: 11px;
  transform: translate(-50%, -50%);
  .close-box {
    background: linear-gradient(to bottom right, rgb(241, 251, 255), white);
    height: 32px;
    border-radius: 11px;
    i {
      cursor: pointer;
      position: absolute;
      right: 12px;
      top: 12px;
    }
  }
}
</style>
